import { gql } from "@apollo/client";

export const GET_EVENTS = gql`
	query GetEvents {
		events {
			nodes {
				id
				name
				costPerPerson
				description
			}
		}
	}
`;

export const GET_EVENT = gql`
	query GetEventDetails($id: UUID!) {
		event(id: $id) {
			id
			name
			costPerPerson
			description
			startDate
			endDate
		}
	}
`;

export const GET_EVENT_SLOTS = gql`
	query GetEventSlots($eventId: UUID!) {
		eventSlots(condition: { eventId: $eventId }) {
			nodes {
				id
				day
				available
				maxReservations
				startTime
				endTime
				duration
			}
		}
	}
`;
